import Analytics from 'analytics';
// @ts-ignore:next-line
import googleTagManager from '@analytics/google-tag-manager';
import {useEffect} from 'react';

/**
 * https://getanalytics.io/plugins/google-tag-manager/
 * https://shopify.github.io/hydrogen-v1/tutorials/analytics/configure-analytics#implement-a-client-analytics-connector
 */

let init = false;
export function GoogleTagManager() {
  useEffect(() => {
    if (!init && import.meta.env.PUBLIC_VERCEL_ENV === 'production') {
      // One-time initialization
      init = true;
      Analytics({
        app: 'mareksound-webstore',
        plugins: [
          googleTagManager({
            containerId: import.meta.env.PUBLIC_GTM_CONTAINER_ID,
          }),
        ],
      });
    }
  });
  return null;
}
